(function () {
  var dictionaries = {
    tr: {
      announcement: "UV400 Pass | EN ISO 12312-1 Cat.3 | FCC Part 15 belgeli akilli ses deneyimi",
      navProduct: "Urun",
      navDetails: "Detay",
      navTrust: "Guven",
      navGallery: "Galeri",
      cartLabel: "Sepet",
      footerCopy: "Bluetooth akilli gunes gozlugu ile gunluk stil ve pratik ses deneyimi.",
      footerTitleOne: "Satis",
      footerProduct: "Urun sayfasi",
      footerCart: "Sepet",
      footerTitleTwo: "Guven",
      footerTitleThree: "Not",
      footerNote: "Siparis, kargo ve iade bilgileri odeme adiminda net olarak gosterilir.",
      productKicker: "Bluetooth akilli gunes gozlugu",
      reviewText: "Gunluk kullanimda sik, pratik ve konforlu",
      buyCopy: "Mat siyah kalin cerceve, koyu Cat.3 cam ve Bluetooth ses deneyimiyle gun icinde telefon gorusmesi ve muzik icin pratik bir secim.",
      quantity: "Adet",
      addToCart: "Sepete ekle",
      goCart: "Sepete git",
      buyNow: "Simdi satin al",
      connectProduct: "Urun secimi",
      orderTotal: "Toplam",
      priceNote: "100 USD karsiligi: 4.706,63 TL",
      cartAdding: "Sepete ekleniyor...",
      checkoutRedirecting: "Odeme sayfasi aciliyor...",
      checkoutPreview: "Shopify'a yuklendiginde odeme sayfasina gecer.",
      cartAdded: "{qty} adet sepete eklendi. Toplam: {total}",
      cartPreviewAdded: "{qty} adet sepete eklendi. Toplam: {total}",
      cartError: "Sepete ekleme basarisiz oldu. Lutfen tekrar dene.",
      cartSetupRequired: "Sepet ozeti",
      closeImage: "Gorseli kapat",
      prevImage: "Onceki gorsel",
      nextImage: "Sonraki gorsel",
      trustOne: "UV400 Pass test bilgisi",
      trustTwo: "EN ISO 12312-1 Cat.3 gunes gozlugu raporu",
      trustThree: "FCC Part 15 audio glasses belgesi",
      trustFour: "Kutulu urun, kese ve sarj kablosu sunumu",
      aboutKicker: "Urun detayi",
      aboutTitle: "Klasik gunes gozlugu gorunumunde akilli ses deneyimi.",
      aboutCopy: "ERC KAIZEN, dis mekanda kullanima uygun siyah gunes gozlugu formunu Bluetooth ses ozelligiyle birlestirir. Telefon gorusmeleri, muzik ve gunluk kullanim icin sade, modern ve tasimasi kolay bir aksesuardir.",
      detailOneTitle: "Mat siyah govde",
      detailOneCopy: "Kalin cerceve, koyu cam ve logosuz mat yuzey premium gorunum verir.",
      detailTwoTitle: "Bluetooth kullanim",
      detailTwoCopy: "Gunluk gorusme ve muzik deneyimi icin akilli gozluk formunda tasarlanmistir.",
      detailThreeTitle: "UV400 ve Cat.3 lens",
      detailThreeCopy: "QIMA raporunda UV400 Pass ve lens kategori Cat.3 bilgisi yer alir.",
      detailFourTitle: "Kutulu teslim",
      detailFourCopy: "Kutu, tasima kesesi ve sarj kablosu ile satis algisi guclendirilir.",
      packageKicker: "Paket icerigi",
      packageTitle: "Kutuyu acan musteri urunun tam set geldigini gorur.",
      packageCopy: "Kutu, gozluk, tasima kesesi ve sarj kablosu birlikte gelir. Hediye ve gunluk kullanim icin duzenli, eksiksiz bir teslim hissi verir.",
      trustKicker: "Guvenlik ve belgeler",
      trustTitle: "Satis metni belge bilgileriyle desteklenir.",
      trustCopy: "Urun belgelerinde UV400 Pass, Cat.3 lens ve FCC Part 15 bilgileri yer alir. Bu bilgiler urunun lens ve elektronik tarafinda temel guven unsurlarini destekler.",
      styleKicker: "Kullanim sahneleri",
      styleTitle: "Kafe, sehir, sahil ve gunluk kullanim pozlarini bir arada gosterir.",
      styleCopy: "Mankenli kareler urunun yuzde durusunu, cerceve kalinligini ve gunluk kombinlerle uyumunu daha net anlatir.",
      videoKicker: "Video vitrini",
      videoTitle: "Urun, kutu ve kullanim hissi videoda da gorunur.",
      faqKicker: "Sik sorulanlar",
      faqTitle: "Satin alma kararini hizlandiran net cevaplar.",
      faqOneQ: "Bu normal gunes gozlugu mu?",
      faqOneA: "Gunes gozlugu formunda Bluetooth ses deneyimi sunan akilli gozluktur.",
      faqTwoQ: "Lens bilgisi nedir?",
      faqTwoA: "QIMA raporunda Cat.3 lens ve UV400 Pass bilgisi yer alir.",
      faqThreeQ: "Nasil siparis verebilirim?",
      faqThreeA: "Adedi secip sepete ekleyebilir, ardindan guvenli odeme adimina gecebilirsin.",
      faqFourQ: "Kutuda neler var?",
      faqFourA: "Kutulu gozluk, tasima kesesi ve sarj kablosu ile teslim edilir.",
      galleryKicker: "Galeri",
      galleryTitle: "Urunu farkli acilardan incele.",
      galleryCopy: "Kutu, cerceve, lens ve gunluk kullanim gorselleri urunu daha net degerlendirmeni saglar."
    },
    en: {
      announcement: "UV400 Pass | EN ISO 12312-1 Cat.3 | Smart audio experience with FCC Part 15 documentation",
      navProduct: "Product",
      navDetails: "Details",
      navTrust: "Trust",
      navGallery: "Gallery",
      cartLabel: "Cart",
      footerCopy: "Bluetooth smart sunglasses for everyday style and practical audio.",
      footerTitleOne: "Sales",
      footerProduct: "Product page",
      footerCart: "Cart",
      footerTitleTwo: "Trust",
      footerTitleThree: "Note",
      footerNote: "Order, shipping and return details are shown clearly during checkout.",
      productKicker: "Bluetooth smart sunglasses",
      reviewText: "Stylish, practical and comfortable for daily use",
      buyCopy: "A matte black frame, dark Cat.3 lenses and Bluetooth audio make it a practical choice for calls and music throughout the day.",
      quantity: "Quantity",
      addToCart: "Add to cart",
      goCart: "Go to cart",
      buyNow: "Buy now",
      connectProduct: "Product selection",
      orderTotal: "Total",
      priceNote: "Base price: 100 USD",
      cartAdding: "Adding to cart...",
      checkoutRedirecting: "Opening checkout...",
      checkoutPreview: "Checkout opens after the theme is uploaded to Shopify.",
      cartAdded: "{qty} item(s) added to cart. Total: {total}",
      cartPreviewAdded: "{qty} item(s) added to cart. Total: {total}",
      cartError: "Could not add to cart. Please try again.",
      cartSetupRequired: "Cart summary",
      closeImage: "Close image",
      prevImage: "Previous image",
      nextImage: "Next image",
      trustOne: "UV400 Pass test information",
      trustTwo: "EN ISO 12312-1 Cat.3 sunglasses report",
      trustThree: "FCC Part 15 audio glasses certificate",
      trustFour: "Boxed product with pouch and charging cable",
      aboutKicker: "About",
      aboutTitle: "Smart audio in a classic sunglasses form.",
      aboutCopy: "ERC KAIZEN combines a black outdoor sunglasses shape with Bluetooth audio. It is made for calls, music and daily use in a clean, modern and easy-to-carry accessory.",
      detailOneTitle: "Matte black body",
      detailOneCopy: "A bold frame, dark lenses and a logo-free matte surface create a premium look.",
      detailTwoTitle: "Bluetooth use",
      detailTwoCopy: "Designed as smart eyewear for daily calls and music.",
      detailThreeTitle: "UV400 and Cat.3 lens",
      detailThreeCopy: "The QIMA report includes UV400 Pass and lens category Cat.3 information.",
      detailFourTitle: "Boxed delivery",
      detailFourCopy: "The box, carrying pouch and charging cable strengthen the perceived value.",
      packageKicker: "Package",
      packageTitle: "The customer sees a complete set when opening the box.",
      packageCopy: "The sunglasses arrive with the box, carrying pouch and charging cable for a complete everyday or gift-ready set.",
      trustKicker: "Safety and documents",
      trustTitle: "The sales copy is supported by document information.",
      trustCopy: "Product documents include UV400 Pass, Cat.3 lens and FCC Part 15 information, supporting the key trust points for lens and electronic use.",
      styleKicker: "Use scenes",
      styleTitle: "Cafe, city, seaside and everyday poses in one flow.",
      styleCopy: "Model shots show the fit on the face, frame thickness and how the glasses work with daily outfits.",
      videoKicker: "Video showcase",
      videoTitle: "The product, box and usage feel are also visible in video.",
      faqKicker: "FAQ",
      faqTitle: "Clear answers that speed up the buying decision.",
      faqOneQ: "Is this a normal pair of sunglasses?",
      faqOneA: "It is smart eyewear with Bluetooth audio in a sunglasses form.",
      faqTwoQ: "What is the lens information?",
      faqTwoA: "The QIMA report includes Cat.3 lens and UV400 Pass information.",
      faqThreeQ: "How can I order?",
      faqThreeA: "Choose the quantity, add the product to cart and continue to secure checkout.",
      faqFourQ: "What is in the box?",
      faqFourA: "Boxed sunglasses, carrying pouch and charging cable are included.",
      galleryKicker: "Gallery",
      galleryTitle: "View the product from different angles.",
      galleryCopy: "Box, frame, lens and daily-use visuals help you evaluate the product clearly."
    },
    de: {
      announcement: "UV400 Pass | EN ISO 12312-1 Cat.3 | Smarte Audio-Erfahrung mit FCC Part 15 Dokumentation",
      navProduct: "Produkt",
      navDetails: "Details",
      navTrust: "Vertrauen",
      navGallery: "Galerie",
      cartLabel: "Warenkorb",
      footerCopy: "Bluetooth-Sonnenbrille fur Alltagsstil und praktisches Audio.",
      footerTitleOne: "Verkauf",
      footerProduct: "Produktseite",
      footerCart: "Warenkorb",
      footerTitleTwo: "Vertrauen",
      footerTitleThree: "Hinweis",
      footerNote: "Bestell-, Versand- und Ruckgabeinformationen werden beim Checkout klar angezeigt.",
      productKicker: "Bluetooth Smart-Sonnenbrille",
      reviewText: "Stilvoll, praktisch und bequem fur den Alltag",
      buyCopy: "Matter schwarzer Rahmen, dunkle Cat.3 Glaser und Bluetooth-Audio machen die Brille praktisch fur Anrufe und Musik im Alltag.",
      quantity: "Menge",
      addToCart: "In den Warenkorb",
      goCart: "Zum Warenkorb",
      buyNow: "Jetzt kaufen",
      connectProduct: "Produktauswahl",
      orderTotal: "Summe",
      priceNote: "Gegenwert von 100 USD: 87,34 EUR",
      cartAdding: "Wird in den Warenkorb gelegt...",
      checkoutRedirecting: "Checkout wird geoffnet...",
      checkoutPreview: "Der Checkout offnet sich nach dem Upload zu Shopify.",
      cartAdded: "{qty} Stuck in den Warenkorb gelegt. Summe: {total}",
      cartPreviewAdded: "{qty} Stuck in den Warenkorb gelegt. Summe: {total}",
      cartError: "Konnte nicht in den Warenkorb gelegt werden. Bitte erneut versuchen.",
      cartSetupRequired: "Warenkorbubersicht",
      closeImage: "Bild schliessen",
      prevImage: "Vorheriges Bild",
      nextImage: "Nachstes Bild",
      trustOne: "UV400 Pass Testinformation",
      trustTwo: "EN ISO 12312-1 Cat.3 Sonnenbrillenbericht",
      trustThree: "FCC Part 15 Audio-Glasses-Zertifikat",
      trustFour: "Box, Beutel und Ladekabel enthalten",
      aboutKicker: "Uber das Produkt",
      aboutTitle: "Smartes Audio in klassischer Sonnenbrillenform.",
      aboutCopy: "ERC KAIZEN kombiniert eine schwarze Sonnenbrille fur draussen mit Bluetooth-Audio. Sie eignet sich fur Anrufe, Musik und den Alltag in einem modernen, leicht tragbaren Accessoire.",
      detailOneTitle: "Matter schwarzer Rahmen",
      detailOneCopy: "Starker Rahmen, dunkle Glaser und eine logofreie matte Oberflache erzeugen einen Premium-Look.",
      detailTwoTitle: "Bluetooth-Nutzung",
      detailTwoCopy: "Als smarte Brille fur tagliche Anrufe und Musik konzipiert.",
      detailThreeTitle: "UV400 und Cat.3",
      detailThreeCopy: "Der QIMA-Bericht nennt UV400 Pass und Linsenkategorie Cat.3.",
      detailFourTitle: "Box-Lieferung",
      detailFourCopy: "Box, Etui und Ladekabel erhohen die wahrgenommene Wertigkeit.",
      packageKicker: "Lieferumfang",
      packageTitle: "Beim Offnen sieht der Kunde ein komplettes Set.",
      packageCopy: "Die Brille wird mit Box, Beutel und Ladekabel geliefert und wirkt dadurch komplett fur Alltag oder Geschenk.",
      trustKicker: "Sicherheit und Dokumente",
      trustTitle: "Der Verkaufstext wird durch Dokumentinformationen gestutzt.",
      trustCopy: "Produktdokumente enthalten UV400 Pass, Cat.3 Linsen und FCC Part 15 Informationen als wichtige Vertrauenspunkte fur Linse und Elektronik.",
      styleKicker: "Nutzungsszenen",
      styleTitle: "Cafe, Stadt, Meer und Alltagsszenen in einer klaren Bildstrecke.",
      styleCopy: "Modelbilder zeigen Sitz im Gesicht, Rahmenstarke und die Wirkung mit Alltagsoutfits.",
      videoKicker: "Video",
      videoTitle: "Produkt, Box und Nutzungsgefuhl sind auch im Video sichtbar.",
      faqKicker: "FAQ",
      faqTitle: "Klare Antworten fur eine schnellere Kaufentscheidung.",
      faqOneQ: "Ist das eine normale Sonnenbrille?",
      faqOneA: "Es ist eine smarte Brille mit Bluetooth-Audio in Sonnenbrillenform.",
      faqTwoQ: "Welche Linseninformation gibt es?",
      faqTwoA: "Der QIMA-Bericht nennt Cat.3 Linsen und UV400 Pass.",
      faqThreeQ: "Wie kann ich bestellen?",
      faqThreeA: "Menge wahlen, in den Warenkorb legen und zum sicheren Checkout gehen.",
      faqFourQ: "Was ist in der Box?",
      faqFourA: "Sonnenbrille, Box, Beutel und Ladekabel sind enthalten.",
      galleryKicker: "Galerie",
      galleryTitle: "Produkt aus verschiedenen Blickwinkeln ansehen.",
      galleryCopy: "Box, Rahmen, Linse und Alltagsbilder helfen bei einer klaren Produktbewertung."
    }
  };

  var activeLang = "tr";
  var cartQuantity = 0;
  var priceByLanguage = {
    tr: { amount: 4706.631, locale: "tr-TR", suffix: " TL" },
    en: { amount: 100, locale: "en-US", currency: "USD" },
    de: { amount: 87.3427, locale: "de-DE", suffix: " EUR" }
  };
  var lightboxItems = [];
  var activeLightboxIndex = 0;

  function getDictionary() {
    return dictionaries[activeLang] || dictionaries.tr;
  }

  function fillTemplate(template, values) {
    return Object.keys(values).reduce(function (text, key) {
      return text.replace(new RegExp("\\{" + key + "\\}", "g"), values[key]);
    }, template);
  }

  function normalizeQuantity(input) {
    var quantity = parseInt(input && input.value, 10);
    if (!Number.isFinite(quantity) || quantity < 1) {
      quantity = 1;
    }
    if (input) {
      input.value = quantity;
    }
    return quantity;
  }

  function formatPrice(quantity) {
    var config = priceByLanguage[activeLang] || priceByLanguage.tr;
    var amount = config.amount * (quantity || 1);
    if (config.currency) {
      return new Intl.NumberFormat(config.locale, {
        style: "currency",
        currency: config.currency
      }).format(amount);
    }
    return new Intl.NumberFormat(config.locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount) + config.suffix;
  }

  function updatePriceDisplays() {
    var dict = getDictionary();
    document.querySelectorAll("[data-price-display]").forEach(function (block) {
      var current = block.querySelector("[data-price-current]");
      var note = block.querySelector("[data-price-note]");
      if (current) {
        current.textContent = formatPrice(1);
      }
      if (note) {
        note.textContent = dict.priceNote;
      }
    });

    document.querySelectorAll(".buy-card").forEach(function (card) {
      var quantityInput = card.querySelector("[data-quantity-input]");
      var totalValue = card.querySelector("[data-order-total-value]");
      if (totalValue) {
        totalValue.textContent = formatPrice(normalizeQuantity(quantityInput));
      }
    });
  }

  function setLanguage(lang) {
    var dict = dictionaries[lang] || dictionaries.tr;
    activeLang = dictionaries[lang] ? lang : "tr";
    document.documentElement.lang = lang;
    document.querySelectorAll("[data-i18n]").forEach(function (node) {
      var key = node.getAttribute("data-i18n");
      if (dict[key]) {
        node.textContent = dict[key];
      }
    });
    document.querySelectorAll("[data-lang]").forEach(function (button) {
      button.classList.toggle("is-active", button.getAttribute("data-lang") === lang);
    });
    try {
      window.localStorage.setItem("ercKaizenLang", lang);
    } catch (error) {
      // Local storage may be unavailable in some preview contexts.
    }
    updatePriceDisplays();
    updateCartLink();
  }

  function initLanguage() {
    var saved = "tr";
    try {
      saved = window.localStorage.getItem("ercKaizenLang") || document.documentElement.lang || "tr";
    } catch (error) {
      saved = document.documentElement.lang || "tr";
    }
    saved = saved.slice(0, 2).toLowerCase();
    if (!dictionaries[saved]) {
      saved = "tr";
    }
    document.querySelectorAll("[data-lang]").forEach(function (button) {
      button.addEventListener("click", function () {
        setLanguage(button.getAttribute("data-lang"));
      });
    });
    setLanguage(saved);
  }

  function initGalleries() {
    document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-gallery-main]");
      if (!main) {
        return;
      }
      gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (button) {
        button.addEventListener("click", function () {
          var next = button.getAttribute("data-gallery-thumb");
          if (!next) {
            return;
          }
          main.removeAttribute("srcset");
          main.removeAttribute("sizes");
          main.src = next;
          gallery.querySelectorAll(".thumb-button").forEach(function (item) {
            item.classList.remove("is-active");
          });
          button.classList.add("is-active");
        });
      });
      main.setAttribute("role", "button");
      main.setAttribute("tabindex", "0");
      main.addEventListener("click", function () {
        openLightbox(main.currentSrc || main.src);
      });
      main.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          openLightbox(main.currentSrc || main.src);
        }
      });
    });
  }

  function collectLightboxItems() {
    var seen = {};
    lightboxItems = [];
    document.querySelectorAll(".main-image img, .package-collage img, .lifestyle-grid img, .archive-grid img").forEach(function (image) {
      var src = image.currentSrc || image.src;
      if (!src || seen[src]) {
        return;
      }
      seen[src] = true;
      lightboxItems.push({
        src: src,
        alt: image.alt || "ERC KAIZEN"
      });
    });
  }

  function ensureLightbox() {
    var existing = document.querySelector("[data-image-lightbox]");
    if (existing) {
      return existing;
    }
    var lightbox = document.createElement("div");
    lightbox.className = "image-lightbox";
    lightbox.setAttribute("data-image-lightbox", "");
    lightbox.setAttribute("aria-hidden", "true");
    lightbox.innerHTML = [
      '<div class="image-lightbox__panel" role="dialog" aria-modal="true">',
      '<button class="image-lightbox__close" type="button" data-lightbox-close aria-label="Close image">&times;</button>',
      '<button class="image-lightbox__nav image-lightbox__nav--prev" type="button" data-lightbox-prev aria-label="Previous image">&lsaquo;</button>',
      '<img data-lightbox-image alt="">',
      '<button class="image-lightbox__nav image-lightbox__nav--next" type="button" data-lightbox-next aria-label="Next image">&rsaquo;</button>',
      "</div>"
    ].join("");
    document.body.appendChild(lightbox);
    lightbox.addEventListener("click", function (event) {
      if (event.target === lightbox || event.target.hasAttribute("data-lightbox-close")) {
        closeLightbox();
      }
      if (event.target.hasAttribute("data-lightbox-prev")) {
        moveLightbox(-1);
      }
      if (event.target.hasAttribute("data-lightbox-next")) {
        moveLightbox(1);
      }
    });
    return lightbox;
  }

  function renderLightbox() {
    var lightbox = ensureLightbox();
    var image = lightbox.querySelector("[data-lightbox-image]");
    var closeButton = lightbox.querySelector("[data-lightbox-close]");
    var prevButton = lightbox.querySelector("[data-lightbox-prev]");
    var nextButton = lightbox.querySelector("[data-lightbox-next]");
    var item = lightboxItems[activeLightboxIndex];
    if (!item) {
      return;
    }
    image.src = item.src;
    image.alt = item.alt;
    closeButton.setAttribute("aria-label", getDictionary().closeImage);
    prevButton.setAttribute("aria-label", getDictionary().prevImage);
    nextButton.setAttribute("aria-label", getDictionary().nextImage);
  }

  function openLightbox(src) {
    if (!src) {
      return;
    }
    collectLightboxItems();
    activeLightboxIndex = Math.max(0, lightboxItems.findIndex(function (item) {
      return item.src === src;
    }));
    var lightbox = ensureLightbox();
    var closeButton = lightbox.querySelector("[data-lightbox-close]");
    renderLightbox();
    lightbox.classList.add("is-open");
    lightbox.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    closeButton.focus();
  }

  function moveLightbox(direction) {
    if (!lightboxItems.length) {
      return;
    }
    activeLightboxIndex = (activeLightboxIndex + direction + lightboxItems.length) % lightboxItems.length;
    renderLightbox();
  }

  function closeLightbox() {
    var lightbox = document.querySelector("[data-image-lightbox]");
    if (!lightbox) {
      return;
    }
    lightbox.classList.remove("is-open");
    lightbox.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function initImageZoom() {
    document.querySelectorAll(".package-collage img, .lifestyle-grid img, .archive-grid img").forEach(function (image) {
      image.setAttribute("tabindex", "0");
      image.setAttribute("role", "button");
      image.addEventListener("click", function () {
        openLightbox(image.currentSrc || image.src);
      });
      image.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          openLightbox(image.currentSrc || image.src);
        }
      });
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeLightbox();
      }
      if (!document.querySelector(".image-lightbox.is-open")) {
        return;
      }
      if (event.key === "ArrowLeft") {
        moveLightbox(-1);
      }
      if (event.key === "ArrowRight") {
        moveLightbox(1);
      }
    });
  }

  function setCartMessage(form, type, text) {
    var message = form.querySelector("[data-cart-message]");
    if (!message) {
      return;
    }
    message.textContent = text;
    message.classList.remove("is-success", "is-error");
    if (type) {
      message.classList.add(type);
    }
  }

  function updateCartLink(quantity) {
    if (typeof quantity === "number") {
      cartQuantity += quantity;
    }
    var cartLink = document.querySelector(".cart-link");
    if (!cartLink) {
      return;
    }
    cartLink.textContent = cartQuantity > 0 ? getDictionary().cartLabel + " (" + cartQuantity + ")" : getDictionary().cartLabel;
  }

  function updatePreviewCartPanel(quantity, total) {
    document.querySelectorAll("[data-preview-cart-panel]").forEach(function (panel) {
      var text = panel.querySelector("[data-preview-cart-text]");
      panel.hidden = false;
      if (text) {
        text.textContent = fillTemplate(getDictionary().cartAdded, {
          qty: quantity,
          total: total
        });
      }
    });
  }

  function previewCart(form, quantity) {
    var total = formatPrice(quantity);
    setCartMessage(form, "is-success", fillTemplate(getDictionary().cartPreviewAdded, {
      qty: quantity,
      total: total
    }));
    updateCartLink(quantity);
    updatePreviewCartPanel(quantity, total);
  }

  function previewCheckout(form, quantity) {
    var total = formatPrice(quantity);
    setCartMessage(form, "is-success", fillTemplate(getDictionary().cartPreviewAdded, {
      qty: quantity,
      total: total
    }) + " " + getDictionary().checkoutPreview);
    updateCartLink(quantity);
    updatePreviewCartPanel(quantity, total);
  }

  function addToShopifyCart(form, quantity, button, redirectToCheckout) {
    var dict = getDictionary();
    var endpoint = (window.ErcKaizenTheme && window.ErcKaizenTheme.cartAddUrl) || "/cart/add.js";
    setCartMessage(form, "", redirectToCheckout ? dict.checkoutRedirecting : dict.cartAdding);
    button.disabled = true;
    fetch(endpoint, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Cart add failed");
        }
        return response.json();
      })
      .then(function () {
        setCartMessage(form, "is-success", fillTemplate(getDictionary().cartAdded, {
          qty: quantity,
          total: formatPrice(quantity)
        }));
        updateCartLink(quantity);
        if (redirectToCheckout) {
          window.location.href = "/checkout";
        }
      })
      .catch(function () {
        setCartMessage(form, "is-error", dict.cartError);
      })
      .finally(function () {
        button.disabled = false;
      });
  }

  function initCartForms() {
    document.querySelectorAll(".product-form").forEach(function (form) {
      var quantityInput = form.querySelector("[data-quantity-input]");
      var button = form.querySelector("[data-add-to-cart]");
      var buyNowButton = form.querySelector("[data-buy-now]");
      if (quantityInput) {
        quantityInput.addEventListener("input", updatePriceDisplays);
        quantityInput.addEventListener("change", updatePriceDisplays);
      }
      if (!button && !buyNowButton) {
        return;
      }

      var submitHandler = function (event) {
        event.preventDefault();
        var quantity = normalizeQuantity(quantityInput);
        updatePriceDisplays();
        if (button.hasAttribute("data-preview-cart") || form.tagName !== "FORM" || !form.querySelector("[name='id']")) {
          previewCart(form, quantity);
          return;
        }
        addToShopifyCart(form, quantity, button);
      };

      var buyNowHandler = function (event) {
        event.preventDefault();
        var quantity = normalizeQuantity(quantityInput);
        updatePriceDisplays();
        if (buyNowButton.hasAttribute("data-preview-checkout") || form.tagName !== "FORM" || !form.querySelector("[name='id']")) {
          previewCheckout(form, quantity);
          return;
        }
        addToShopifyCart(form, quantity, buyNowButton, true);
      };

      if (button && form.tagName === "FORM") {
        form.addEventListener("submit", submitHandler);
      } else if (button) {
        button.addEventListener("click", submitHandler);
      }
      if (buyNowButton) {
        buyNowButton.addEventListener("click", buyNowHandler);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initLanguage();
    initGalleries();
    initImageZoom();
    initCartForms();
    updatePriceDisplays();
  });
})();
